import { useRequest } from "hooks";
import type { ResourceResponse, ThunkReturnType } from "types";
import { ApiRouteTypes } from "consts/enpoints/api";
import useExportTable from "hooks/useExportTable";
import type { IbanXsBank, IbanXsBanksResponse } from "../types";
import { getIbanXsBanksThunk, updateIbanXsBankThunk } from "../thunks";
import { changeExportIbanXsBanksLoading as changeExportLoading } from "../slice";

export const useIbanXSActions = () => {
    const getIbanXsBanks = useRequest<
        ThunkReturnType<IbanXsBanksResponse>,
        string | undefined
    >({
        thunk: getIbanXsBanksThunk
    });

    const updateIbanXsBank = useRequest<
        ThunkReturnType<ResourceResponse<IbanXsBank>>,
        Partial<IbanXsBank>
    >({
        thunk: updateIbanXsBankThunk
    })

    const downloadCsv = useExportTable({
        changeExportLoading,
        apiResourceType: ApiRouteTypes.GetIbanXsBanks
    });

    return {
        getIbanXsBanks,
        updateIbanXsBank,
        downloadCsv
    };
};

export default useIbanXSActions;
